import React from 'react';
import { CheckIcon, LockIcon, ShieldCheckIcon, ZapIcon } from 'lucide-react';
import { checkoutUrl, mockupUrl, offerAnchor, productName } from '../data/content';
import { checkoutFeatures, pricing } from '../data/bonuses';
import { Button } from './ui/Button';
import { OfferLink } from './ui/OfferLink';
export function Pricing() {
  return <section id="offer" className="scroll-mt-4 bg-brand-deep px-4 py-12 md:py-16" aria-labelledby="offer-title" data-id="element-147" data-mp="3nrw2rfrt9sto">
      <div className="mx-auto max-w-xl" data-id="element-148" data-mp="f9q5gr3gkd15">
        <div className="text-center" data-id="element-149" data-mp="kbfgw7ulespr">
          <p className="text-[11px] font-black uppercase tracking-[.2em] text-gold-light md:text-xs" data-id="element-150" data-mp="kadytjf5t5yj">
            Special launch offer
          </p>
          <h2 id="offer-title" className="mt-2 text-2xl font-black uppercase leading-tight text-white md:text-3xl" data-id="element-151" data-mp="acgbqz91df7i">
            {productName}
          </h2>
        </div>

        <article className="mt-8 rounded-3xl border-4 border-gold bg-white p-6 shadow-2xl md:p-8" data-id="element-152" data-mp="2r3q3z9hklunb">
          <OfferLink href={offerAnchor} className="mx-auto max-w-[260px]" label={`${productName} offer`} data-id="element-153" data-mp="2v0m5n8d521s3">
            <img src={mockupUrl} alt={`${productName} 3D product mockup`} className="w-full object-contain transition-transform duration-300 ease-out group-hover:scale-[1.015]" data-id="element-154" data-mp="2fpfcccmbcbnp" />
          </OfferLink>

          <p className="mt-6 text-center text-sm font-black uppercase tracking-wide text-brand-deep" data-id="element-155" data-mp="2klw3lfot7650">
            5 Complete Volumes + 5 Practical Bonuses
          </p>
          <p className="mt-2 text-center text-sm" data-id="element-156" data-mp="2tnvmkdjdwkal">
            <span className="font-semibold text-slate-600" data-id="element-157" data-mp="2tn3qz2psemkb">Bonus value </span>
            <span className="font-bold text-slate-500 line-through decoration-red-600 decoration-2" data-id="element-158" data-mp="38ayk2k7pisxx">
              ${pricing.bonusValue} USD
            </span>
            <span className="ml-2 font-black uppercase text-brand" data-id="element-159" data-mp="3hcohc6o9sm3m">Free</span>
          </p>

          <ul className="mx-auto mt-6 flex w-fit flex-col gap-2" data-id="element-160" data-mp="3ce4wk9lexgcu">
            {checkoutFeatures.map(item => <li key={item} className="flex items-start gap-2 text-sm font-medium text-brand-deep" data-id="element-161" data-mp="2a0yw1c1rgbaj">
                <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-gold-dark" aria-hidden="true" data-id="element-162" data-mp="2eyqoq8a8c1fs" />
                {item}
              </li>)}
          </ul>

          <p className="mt-8 text-center text-4xl font-black text-brand-deep" data-id="element-163" data-mp="2nrtya5hr7u55">
            ${pricing.price} <span className="text-base font-bold text-slate-500" data-id="element-164" data-mp="2ntohnfddne74">USD</span>
          </p>
          <div className="mt-4" data-id="element-165" data-mp="2st1624jwctbt">
            <Button href={checkoutUrl} size="lg" fullWidth subtext="Instant Digital Delivery" data-id="element-166" data-mp="2xpi5huwjqu47">
              Get instant access — ${pricing.price}
            </Button>
          </div>
          <ul className="mt-5 flex flex-wrap justify-center gap-x-4 gap-y-2 text-[10px] font-extrabold uppercase text-slate-600" data-id="element-167" data-mp="36qppd7ybfser">
            <li className="flex items-center gap-1.5" data-id="element-168" data-mp="18bv2zut8jsmb">
              <ZapIcon className="h-3.5 w-3.5 text-brand" aria-hidden="true" data-id="element-169" data-mp="18dg27xqhvzqi" /> Instant Digital Delivery
            </li>
            <li className="flex items-center gap-1.5" data-id="element-170" data-mp="14sw3hpbn74he">
              <ShieldCheckIcon className="h-3.5 w-3.5 text-brand" aria-hidden="true" data-id="element-171" data-mp="14ugvp8ahibc3" /> 7-Day Guarantee
            </li>
            <li className="flex items-center gap-1.5" data-id="element-172" data-mp="100mfwfy02gia">
              <LockIcon className="h-3.5 w-3.5 text-brand" aria-hidden="true" data-id="element-173" data-mp="v45s5mupq45q" /> Secure Payment
            </li>
          </ul>
        </article>
      </div>
    </section>;
}